module.exports = __webpack_public_path__ + "img/icon1.2ca5c377.png";